module.exports = __webpack_public_path__ + "img/marketplace_Twitter.f996f67e.svg";